import { Component, HostBinding } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-info-group-value',
	templateUrl: './info-group-value.component.html',
	styleUrls: ['./info-group-value.component.scss'],
})
export class InfoGroupValueComponent {

	@HostBinding('class') public readonly klassName: string = `qe-info-group-value`;
	@HostBinding('attr.role') public readonly ariaRole: string = `paragraph`;

	constructor() { }
}
